// extracted by mini-css-extract-plugin
module.exports = {"postContent":"Post_postContent__JaWv9","shortText":"Post_shortText__AlPG3"};